/**
 * LoggedIn form component.
 *
 * @returns {JSX.Element}
 */
// State action for update/set rule config.
import {useDispatch} from 'react-redux';
import {setRuleConfig} from "@app/modules/PersonaForm/store/PersonaFormStore";
import {useEffect} from "react";

export default function LoggedIn() {

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setRuleConfig(
			{
				id: 'LoggedIn',
				config: {
					ruleType: "login",
					args: {
						login_state: true
					},
				}
			}
		));
	}, []);

	return <>
		<p>
			This
			rule
			targets
			logged-in
			users.
		</p>
	</>;
}
